export const CREDIT_NOTES_ROUTES = {
    CREATE: "/{service_company_slug}/credit-notes/create/",
    LIST: "/{service_company_slug}/credit-notes/",
    COUNT: "/{service_company_slug}/api/credit-notes/count/",
    LIGHTWEIGHT_LIST: "/{service_company_slug}/api/credit-notes/lightweight/",
    UPDATE: "/{service_company_slug}/credit-notes/{id}/update/",
    DETAILS: "/{service_company_slug}/credit-notes/{id}/",
}
